// extracted by mini-css-extract-plugin
export default {"tr":"MasterAdmins_tr__xOUMW","title":"MasterAdmins_title__xyawS","header":"MasterAdmins_header__CE2EH","usersAndAccountsWrapper":"MasterAdmins_usersAndAccountsWrapper__RGuoH"};